import React, { useState } from 'react'
import { Icon, Button, Typography, Menu, MenuItem, SvgIcon } from 'components'
import classNames from 'classnames'
import { makeStyles } from '@material-ui/core/styles'
import { colors } from 'constants/index'
import { ReactComponent as BankIcon } from 'static/BankIcon.svg'

const useStyles = makeStyles({
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    borderBottom: `1px solid ${colors.BASIC.COLOR[5]}`,
    marginBottom: 24,
    paddingBottom: 20,
    alignItems: 'center',
    '&:last-child': {
      borderBottom: 'none',
      marginBottom: 0,
      paddingBottom: 0,
    },
  },
  containerForMeeting: {
    borderBottom: 'none',
    marginBottom: 0,
  },
  bankIcon: {
    height: 42,
    width: 64,
    marginRight: 16,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  bankInfo: {
    display: 'flex',
    alignItems: 'center',
  },
  defaultMark: {
    border: `solid 1px ${colors.BASIC.COLOR[10]}`,
    backgroundColor: colors.BASIC.COLOR[0],
    color: colors.BASIC.COLOR[70],
    height: 32,
    borderRadius: 4,
    display: 'flex',
    alignItems: 'center',
    padding: '6.5px 12px',
  },
  buttonGroup: {
    display: 'flex',
    alignItems: 'center',
  },
  icon: {
    fontSize: 24,
  },
  button: {
    marginLeft: 8,
    border: `1px solid ${colors.BASIC.COLOR[10]}`,
    backgroundColor: colors.BASIC.COLOR[0],
    padding: 3,
    minWidth: 0,
    color: colors.BASIC.COLOR[70],
  },
  subtitle: {
    color: colors.BASIC.COLOR[20],
  },
  title: {
    marginBottom: 4,
  },
  menu: {
    width: 195,
    padding: '0 10px',
  },
  statusBadge: {
    display: 'inline-block',
    padding: '4px 12px',
    borderRadius: 16,
    fontSize: '12px',
    fontWeight: 500,
    marginLeft: 8,
  },
  statusPending: {
    backgroundColor: '#F5F5DC', // Light beige
    color: colors.BASIC.COLOR[80], // Dark blue
  },
  statusReady: {
    backgroundColor: '#E8F5E8', // Light green
    color: colors.SUCCESS,
  },
  statusFailed: {
    backgroundColor: '#FFE8E8', // Light red
    color: colors.ERROR,
  },
  '@media(max-width:767px)': {
    defaultMark: {
      padding: '6.5px 8px',
    },
  },
})

const DefaultMark = () => {
  const classes = useStyles()
  return (
    <div className={classes.defaultMark}>
      <Typography variant="body2">default</Typography>
    </div>
  )
}

const getStatusBadge = (status, classes) => {
  const statusClasses = {
    pending_verification: classes.statusPending,
    ready: classes.statusReady,
    failed: classes.statusFailed,
  }

  const statusLabels = {
    pending_verification: 'Pending Verification',
    ready: 'Ready',
    failed: 'Verification Failed',
  }

  return (
    <span className={classNames(classes.statusBadge, statusClasses[status])}>{statusLabels[status] || status}</span>
  )
}

const BankRow = props => {
  const classes = useStyles()
  const { bankData, onSetDefault, onDeleteBank, showConfigurationButton = false, variant } = props
  const [anchorEl, setAnchorEl] = useState(null)

  const handleClick = event => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const onDeletePress = () => {
    onDeleteBank(bankData.uuid)
    handleClose()
  }

  const onSetDefaultPress = () => {
    onSetDefault(bankData.uuid)
    handleClose()
  }

  return (
    <div className={classNames(classes.container, { [classes.containerForMeeting]: variant === 'setupMeeting' })}>
      <div className={classes.bankInfo}>
        <SvgIcon viewBox="0 0 64 42" className={classes.bankIcon}>
          <BankIcon />
        </SvgIcon>
        <div>
          <Typography variant="body1" className={classes.title}>
            Routing number: •••• {bankData.account_last_4_digits}
            {getStatusBadge(bankData.status, classes)}
          </Typography>
        </div>
      </div>
      <div className={classes.buttonGroup}>
        {bankData.is_default && <DefaultMark />}
        {showConfigurationButton && (
          <>
            <Button variant="text" className={classes.button} onClick={handleClick}>
              <Icon iconClass="las la-cog" style={classes.icon} />
            </Button>
            <Menu
              id="simple-menu"
              anchorEl={anchorEl}
              keepMounted
              open={Boolean(anchorEl)}
              onClose={handleClose}
              classes={{ paper: classes.menu }}
            >
              {!bankData.is_default && bankData.status === 'ready' && (
                <MenuItem onClick={onSetDefaultPress} classes={{ root: classes.menuItem }}>
                  make default
                </MenuItem>
              )}
              <MenuItem onClick={onDeletePress}>remove</MenuItem>
            </Menu>
          </>
        )}
      </div>
    </div>
  )
}

export default BankRow
